"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPaymentsWidgets = void 0;
var PaymentCardList_1 = require("./PaymentCardList");
var PaymentChoiceWidget_1 = require("./PaymentChoiceWidget");
var PaymentCompleteWidget_1 = require("./PaymentCompleteWidget");
var PaymentFailureAlertWidget_1 = require("./PaymentFailureAlertWidget");
var PaymentProcessingWidget_1 = require("./PaymentProcessingWidget");
var PaymentReasonPanelWidget_1 = require("./PaymentReasonPanelWidget");
var UwFailurePaymentReasonPanelWidget_1 = require("./UwFailurePaymentReasonPanelWidget");
var PaymentsHeaderWidget_1 = require("./PaymentsHeaderWidget");
var CurrencyAmountDisplayWidget_1 = require("./CurrencyAmountDisplayWidget");
var AnnualPaymentPanelWidget_1 = require("../annual/common/AnnualPaymentPanelWidget");
var NewMonthlyPayWidget_1 = require("./NewMonthlyPayWidget");
var CancelPageWithInFlightBox_1 = require("./CancelPageWithInFlightBox");
var UpfrontInterestAmountDisplayWidget_1 = require("./UpfrontInterestAmountDisplayWidget");
var HTMLCurrencyOutputWidget_1 = require("./HTMLCurrencyOutputWidget");
var addPaymentsWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentCardList",
        component: PaymentCardList_1.PaymentCardList
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentChoice",
        component: PaymentChoiceWidget_1.PaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentCompleteOutput",
        component: PaymentCompleteWidget_1.PaymentCompleteWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentFailureAlert",
        component: PaymentFailureAlertWidget_1.PaymentFailureAlertWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentProcessingOutput",
        component: PaymentProcessingWidget_1.PaymentProcessingWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentReasonPanelOutput",
        component: PaymentReasonPanelWidget_1.PaymentReasonPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "uwFailurePaymentReasonPanelOutput",
        component: UwFailurePaymentReasonPanelWidget_1.UwFailurePaymentReasonPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentsHeader",
        component: PaymentsHeaderWidget_1.PaymentsHeaderWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "currencyAmountDisplay",
        component: CurrencyAmountDisplayWidget_1.CurrencyAmountDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "htmlCurrencyOutput",
        component: HTMLCurrencyOutputWidget_1.HTMLCurrencyOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualPaymentPanelOutput",
        component: AnnualPaymentPanelWidget_1.AnnualPaymentPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "newMonthlyPay",
        component: NewMonthlyPayWidget_1.NewMonthlyPayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancelPageWithInFlightBox",
        component: CancelPageWithInFlightBox_1.CancelPageWithInFlightBox
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "upfrontInterestAmountDisplayOutput",
        component: UpfrontInterestAmountDisplayWidget_1.UpfrontInterestAmountDisplayWidget
    });
};
exports.addPaymentsWidgets = addPaymentsWidgets;
//# sourceMappingURL=index.js.map